// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"f0342290","290":"763af1a8","607":"da7b117a","789":"a023acb5"}[chunkId] + ".chunk.js";
};